import Immutable from 'immutable';
import Image from './image';

const ProfileRecord = Immutable.Record({
  id: 0,
  address: Immutable.Map(),
  uuid: '',
  profileId: '',
  email: '',
  phone: '',
  siteUrl: '',
  name: '(알수없음)',
  statusMessage: '',
  friendCount: 0,
  spamLevel: 0,
  consult: Immutable.Map(),
  coverImage: new Image(),
  profileImage: new Image(),
  category: Immutable.Map(),
  call2action: Immutable.Map(),
  permalink: '',
  isOfficial: false,
  businessPartnerInfo: Immutable.Map(),
  isFriend: false,
  isChatBot: false,
  isAdult: false,
  authInfo: Immutable.Map(),
  verificationType: ''
});

class Profile extends ProfileRecord {
  getSchemeHost() {
    return `plusfriend/home/${this.uuid}`;
  }

  getScheme(deviceName) {
    const schemeHost = this.getSchemeHost();
    if (deviceName === 'Android') {
      return `kakaoplus://${schemeHost}`;
    }
    return `${process.env.REACT_APP_PF_CUSTOM_SCHEME}://${schemeHost}`;
  }
};

export const fillDetails = (profile, entities) => {
  if (!profile) {
    return null;
  }
  const images = entities.get('images', Immutable.Map());
  return profile
    .update('coverImage', image => images.get(`${image}`, new Image()))
    .update('profileImage', image => images.get(`${image}`, new Image()));
};

export default Profile;



// WEBPACK FOOTER //
// ./src/models/profile.js